// extracted by mini-css-extract-plugin
export var screenLg = "992px";
export var screenXl = "1200px";
export var screenMd = "768px";
export var screenXlMax = "1199px";
export var screenLgMax = "991px";
export var screenMdMax = "767px";
export var screenSmMax = "575px";
export var video = "Video-module--video--29qMt";
export var video__poster = "Video-module--video__poster--3jUls";
export var video__element = "Video-module--video__element--_Q4wa";
export var video__elementActive = "Video-module--video__element--active--3opTh";
export var video__container = "Video-module--video__container--Ys5bY";